import { Component, ChangeDetectionStrategy } from "@angular/core";
import { VersionCheckService } from "src/app/core/services/version-check.service";
import { TranslocoModule, provideTranslocoScope } from "@jsverse/transloco";

@Component({
  selector: "app-version-check-bar",
  imports: [TranslocoModule],
  providers: [provideTranslocoScope("dialogs")],
  templateUrl: "./version-check-bar.component.html",
  styleUrls: ["./version-check-bar.component.scss"],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VersionCheckBarComponent {
  constructor(protected readonly versionCheckService: VersionCheckService) {}
}
